import Cookies from "../../../foundation/cookies";
import "../../../foundation/forms";
import { sendGAPageView, sendVisitSignup } from "../../../foundation/utils/tracking";
import { toCamelCase } from "../../../foundation/utils/string";
import PreactDOMComponent from "../../../foundation/utils/preact-dom-component";
import SignupPage from "../../containers/LoginSignup/pages/SignupPage";
import getAnonymousUserId from "../../../foundation/utils/signup/getAnonymousUserId";

const signupPageContainer = document.getElementById("signupPageContainer");
const SignupPageComponent = new PreactDOMComponent(SignupPage, signupPageContainer);

sendGAPageView();
sendVisitSignup();

const signupParams = {};
const signupToken = Cookies.get("signupToken");
Cookies.remove("signupToken");

let utmParams;

if (Cookies.get("utmParams")) {
    utmParams = JSON.parse(Cookies.get("utmParams"));

    if (utmParams.medium === "email") {
        mixpanel.master.track("Clicked invitation email");
    }

    signupParams.utm = utmParams;
}

function processUrlParams() {
    if (location.search) {
        location.search.substr(1).split("&").forEach(function (param) {
            var kv = param.split("=");
            signupParams[toCamelCase(decodeURIComponent(kv[0]))] = decodeURIComponent(kv[1]);
        });

        history.replaceState({}, "Zeplin - Login", location.pathname);
    }
}

function render() {
    SignupPageComponent.render({
        signupParams,
        signupToken
    });
}

processUrlParams();
render();

mixpanel.master.track("Visited sign up page", {
    "Anonymous UserID": getAnonymousUserId(),
    "Experiment": signupParams.freeTrial ? "Free trial on" : "Free trial off"
});
